import React from 'react';
import {Route, Routes} from "react-router-dom";
import Ptn from "./ptn/index"
import Manbalar from './manbalar/index'
import Daryolar from './daryolar/index'

const LimitSahifa = () => {
    return (
        <Routes>
            <Route path="/*" element={
                <Ptn />
            }/>
            <Route path="/manbalar/*" element={
                <Manbalar />
            }/>
            <Route path="/daryolar/*" element={
                <Daryolar />
            }/>
            <Route path="/ptn/*" element={
                <Ptn />
            }/>
        </Routes>
        // <div>
        //     <div className="tabs-content table-box">
        //         <div className="tabs-content-item active">
        //
        //         </div>
        //         {/*<div className={toggle ==1 ? "tabs-content-item active" : "tabs-content-item"}>*/}
        //         {/*    <Table17 />*/}
        //         {/*</div>*/}
        //         {/*<div className={toggle ==2 ? "tabs-content-item active" : "tabs-content-item"}>*/}
        //         {/*    <Table18 />*/}
        //         {/*</div>*/}
        //         {/*<div className={toggle ==3 ? "tabs-content-item active" : "tabs-content-item"}>*/}
        //         {/*    <Table19 />*/}
        //         {/*</div>*/}
        //         {/*<div className={toggle ==4 ? "tabs-content-item active" : "tabs-content-item"}>*/}
        //         {/*    <Table20 />*/}
        //         {/*</div>*/}
        //     </div>
        // </div>
    );
};

export default LimitSahifa;